// Application configuration
export default {
  serverUrl: 'https://apptest.warhall.eu',
  // Secret token for the mass-report reviewer URL: /Catalogue?review=<reviewToken>
  reviewToken: 'wh-cr-2026',
};
